import React from "react";
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import { StarIcon } from "assets/icons";

const ONBOARDING_STORAGE_KEY = "jobbiz-onboarding-mission-templates-v1";

const MissionTemplateLink = () => {
    return (
        <SidebarUnitDesktop
            routeName={"Fiches de postes"}
            routeSidebar={"/missionTemplates"}
            icon={StarIcon}
            text={"Fiches de postes"}
            onboardingTitle={"Nouveau"}
            onboardingDescription={
                "Configurez une fiche de poste une fois et réutilisez-la à chaque mission. Accédez-y à tout moment depuis ce menu."
            }
            onboardingStorageKey={ONBOARDING_STORAGE_KEY}
            onboardingPointerPlacement="left"
        />
    );
};

export default MissionTemplateLink;
